export default __webpack_public_path__ + "static/media/icon_pre_launch_badge.1647e87d.png";